import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_employee_form_field_email = _resolveComponent("employee-form-field-email")!
  const _component_employee_form_field_first_name = _resolveComponent("employee-form-field-first-name")!
  const _component_employee_form_field_last_name = _resolveComponent("employee-form-field-last-name")!
  const _component_employee_form_field_password = _resolveComponent("employee-form-field-password")!
  const _component_employee_form_field_repeat_password = _resolveComponent("employee-form-field-repeat-password")!
  const _component_employee_form_field_roles = _resolveComponent("employee-form-field-roles")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createBlock(_component_q_form, {
    ref: "form",
    class: "q-gutter-md",
    greedy: "",
    onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_employee_form_field_email, {
        modelValue: _ctx.employeeModel.email,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.employeeModel.email) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_employee_form_field_first_name, {
        modelValue: _ctx.employeeModel.firstName,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.employeeModel.firstName) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_employee_form_field_last_name, {
        modelValue: _ctx.employeeModel.lastName,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.employeeModel.lastName) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_employee_form_field_password, {
        modelValue: _ctx.employeeModel.password,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.employeeModel.password) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_employee_form_field_repeat_password, {
        modelValue: _ctx.employeeModel.repeatPassword,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.employeeModel.repeatPassword) = $event)),
        password: _ctx.employeeModel.password
      }, null, 8, ["modelValue", "password"]),
      _createVNode(_component_employee_form_field_roles, {
        modelValue: _ctx.employeeModel.roles,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.employeeModel.roles) = $event)),
        class: "q-px-sm"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_q_btn, {
        color: "primary",
        label: "Add Employee",
        "no-caps": "",
        type: "submit",
        unelevated: ""
      }),
      _createVNode(_component_q_btn, {
        to: { name: _ctx.routesNames.LIST, query: { page: _ctx.route.query.page } },
        color: "primary",
        label: "Back to listing",
        "no-caps": "",
        outline: ""
      }, null, 8, ["to"])
    ]),
    _: 1
  }, 8, ["onSubmit"]))
}